"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAuthFormOverlayContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.FdrAuthFormOverlayContent = styled_components_1.default.div(({ theme, theme: { space } }) => ({
    padding: space[4],
    '.auth-form-title': theme.auth.formTitleStyles,
    '.auth-form-text': theme.auth.formTextStyles,
}));
//# sourceMappingURL=fdr-auth-form-overlay.styles.js.map